import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertData } from '../../../../../core/models';
import { AlertDialogType } from '../../../../../core/enums';
import { MatButton } from '@angular/material/button';
import { DialogComponent } from '../../../../../core/models/dialog.data';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { BannerComponent } from '../banner/banner.component';
import { MatError, MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'dbx-alert-dialog',
  imports: [
    MatDialogTitle,
    TranslatePipe,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    ReactiveFormsModule,
    BannerComponent,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatProgressSpinnerModule,
  ],
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
})
export class AlertDialogComponent extends DialogComponent<
  AlertDialogComponent,
  void,
  {
    confirmed: boolean;
    mfaCode?: string;
  }
> {
  private readonly formBuilder = inject(FormBuilder);

  protected readonly AlertDialogType = AlertDialogType;
  protected readonly data: AlertData = inject(MAT_DIALOG_DATA);
  protected isLoading = signal<boolean>(false);

  protected formGroup = this.formBuilder.group({
    mfaCode: this.formBuilder.control<string>(
      '',
      this.data.mfaRequired ? [Validators.required, Validators.minLength(6), Validators.maxLength(6)] : [],
    ),
  });

  confirm(): void {
    this.isLoading.set(true);

    if (this.data.confirmCallback) {
      this.data.confirmCallback(this.formGroup.value.mfaCode ?? undefined).subscribe({
        next: () => {
          this.dialogRef.close({ confirmed: true });
        },
        error: () => {
          this.isLoading.set(false);
        },
      });
    } else {
      this.dialogRef.close({
        confirmed: true,
        mfaCode: this.formGroup.value.mfaCode,
      });
    }
  }

  override close(request?: { confirmed: boolean; mfaCode?: string }): void {
    this.dialogRef.close({ confirmed: false });
  }
}
